import React from "react";
import { LoadIndicator } from "devextreme-react";
import { AxiosResponse } from "axios";
import SimpleGridService from "../../services/SimpleGridService";
import DataGrid, {
    Pager,
    Paging,
    Export,
    FilterRow,
    Column,
    Scrolling,
    Editing,
    Texts,
    SearchPanel,
    Selection,
    FilterPanel,
    GroupPanel,
} from "devextreme-react/data-grid";
import sharedUtils from "../grid/sharedUtilities";
import { onExportingEvent } from "../../types/DevExtremeTypes";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver";
interface RelatedItemForClientPromotionProps {
    billableItemId: any;
}

interface RelatedItemForClientPromotionState {
    showProgressIndicator: boolean;
    relatedItemDataSource: any[];
}

class RelatedItemForClientPromotion extends React.Component<RelatedItemForClientPromotionProps> {
    state: RelatedItemForClientPromotionState;
    eventukgridservice: SimpleGridService;
    sharedUtils: sharedUtils;
    dataGridRef: any;
    constructor(props: RelatedItemForClientPromotionProps) {
        super(props);
        this.state = {
            showProgressIndicator: false,
            relatedItemDataSource: [],
        };

        this.eventukgridservice = new SimpleGridService();
        this.sharedUtils = new sharedUtils();
        this.handleSuccess = this.handleSuccess.bind(this);
        this.handleError = this.handleError.bind(this);
        this.dataGridRef = React.createRef();
    }

    componentDidUpdate(
        prevProps: Readonly<RelatedItemForClientPromotionProps>,
        prevState: Readonly<{}>,
        snapshot?: any
    ): void {
        if (this.props.billableItemId != "" && this.props.billableItemId != prevProps.billableItemId) {
            this.relatedItemGridDataSource(this.props.billableItemId);
        }
    }
    relatedItemGridDataSource(billableItemId: string) {
        this.setState({
            showProgressIndicator: true,
        });
        this.eventukgridservice
            .getRelatedItemForClientPromotion(billableItemId)
            .then(this.handleSuccess)
            .catch(this.handleError);
    }
    handleSuccess(response: AxiosResponse<any>) {
        this.setState({
            showProgressIndicator: false,
            relatedItemDataSource: response.data.data.relatedItemGrid,
        });
    }
    handleError(error: AxiosResponse<any>) {
        this.setState({
            showProgressIndicator: false,
            relatedItemDataSource: [],
        });
        var respMessage: string = "Manage Shift Grid data load failed with response: " + JSON.stringify(error);

        if (!this.eventukgridservice.traceAsErrorToAppInsights(respMessage)) {
            // AppInsights is not available
            console.error(respMessage);
        }
    }
    dateCellDisplayContent = (cellInfo: any) => {
        return (
            <div className="container-fluid">
                {cellInfo.data.date ? this.sharedUtils.convertTZDateToDDMMYYY(cellInfo.data.date) : ""}
            </div>
        );
    };
    promotionDateCellDisplayContent = (cellInfo: any) => {
        return (
            <div className="container-fluid">
                {cellInfo.data.lastUpdatedOn
                    ? this.sharedUtils.convertTZDateToDDMMYYY(cellInfo.data.lastUpdatedOn)
                    : ""}
            </div>
        );
    };
    onExporting = (e: onExportingEvent) => {
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet("Main sheet");
    
            exportDataGrid({
                component: e.component,
                worksheet: worksheet,
                autoFilterEnabled: true
            }).then(() => {
                workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer], { type: "application/octet-stream" }), "DataGrid.xlsx");
                });
            });
            e.cancel = true;
        }
    render() {
        return (
            <div>
                {this.state.showProgressIndicator ? (
                    <div className="starter-template">
                        <LoadIndicator
                            id="simple-grid-indicator"
                            height={100}
                            width={100}
                            visible={this.state.showProgressIndicator}
                        />
                    </div>
                ) : (
                    <DataGrid
                        dataSource={this.state.relatedItemDataSource}
                        showBorders={false}
                        showColumnLines={false}
                        hoverStateEnabled={true}
                        columnAutoWidth={true}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        columnResizingMode={"widget"}
                        onExporting={this.onExporting}
                        //ref="dataGridRef"
                        ref={(ref) => {
                            this.dataGridRef = ref;
                        }}
                    >
                        <GroupPanel visible={true} />
                        <FilterPanel visible={true}></FilterPanel>
                        <SearchPanel visible={true} placeholder={"Search"} />
                        <Editing>
                            <Texts confirmDeleteMessage=""></Texts>
                        </Editing>
                        <Scrolling useNative={true} showScrollbar={"onHover"} />
                        <Export enabled={true} allowExportSelectedData={true} />
                        <Selection mode={"multiple"} />

                        <Paging defaultPageSize={10} />
                        <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10, 20]} showInfo={true} />

                        <Column dataField="id" caption="ID" />
                        <Column dataField="clientId" caption="CLIENT ID" />
                        <Column dataField="clientName" caption="CLIENT NAME" />
                        <Column dataField="providerId" caption="PROVIDER ID" />
                        <Column dataField="providerName" caption="PROVIDER NAME" />
                        <Column dataField="date" caption="Date" cellRender={this.dateCellDisplayContent} />
                        <Column dataField="providerNet" caption="PROVIDER NET" />
                        <Column dataField="promotionId" caption="PROMOTION ID" />
                        <Column
                            dataField="lastUpdatedOn"
                            caption="PROMOTION DATETIME"
                            cellRender={this.promotionDateCellDisplayContent}
                        />
                        <Column dataField="eventTitle" caption="PROMOTION EVENT" />
                        <Column dataField="promotionBillableItemId" caption="INVOICE ITEM ID" />
                        <Column dataField="invoiceStatus" caption="INVOICE STATUS" />
                        <Column dataField="invoiceId" caption="INVOICE ID" />
                        <FilterRow visible={true} applyFilter="auto" />
                    </DataGrid>
                )}
            </div>
        );
    }
}

export default RelatedItemForClientPromotion;
